//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { mapModel } from 'src/util/helper';

import OverviewOfferCard from 'components/overview/OverviewOfferCard';
import SetupFacebook from 'components/facebook/SetupFacebook';
import GenderChart from 'components/analytics/GenderChart';
import GeoTable from 'components/analytics/GeoTable';
import AnalyticsChartCard from 'components/analytics/AnalyticsChartCard';

import TOOLTIPS from 'src/resources/insights_tooltips_de.hjson';

export default {
	name: 'AnalyticsPage',

	TOOLTIPS,

	components: {
		OverviewOfferCard,
		SetupFacebook,
		AnalyticsChartCard,
		GenderChart,
		GeoTable,
	},

	data: () => ({
		connectedPage: null,
		tab: 'fans',
		rangeOptions: [
			{ label: 'Letzte Woche', value: 'last_week_mon_sun' },
			{ label: 'Diese Woche', value: 'this_week_mon_today' },
			{ label: 'Dieser Monat', value: 'this_month' },
			{ label: 'Letzter Monat', value: 'last_month' },
		],
	}),

	computed: {
		...mapState('auth', ['currentUser']),
		...mapModel('pageInsights', ['selectedRange']),
		...mapState('pageInsights', [
			'loading',
			'stats',
			'pageViewSum',
			'pageViewChart',
			'pageLikesSum',
			'pageLikesChart',
			'pageActionsSum',
			'pageActionsChart',
			'postEngagementSum',
			'postEngagementChart',
			'pageFollowsSum',
			'pageFollowsChart',
			'pageFollowsGenderAgeChart',
			'pageFollowsCity',
			'pageFollowsCountry',
			'pageFollowsLocale',
			'pageImpressionsSum',
			'pageImpressionsChart',
			'pageFansGenderAgeChart',
			'pageFansCity',
			'pageFansLocale',
			'pageFansCountry',
			'pageImpressionByAgeGenderUniqueChart',
			'pageImpressionByCityUnique',
			'pageImpressionByCountryUnique',
			'pageImpressionByLocalUnique',
			'pageContentActivityByAgeGenderUniqueChart',
			'pageContentActivityByCityUnique',
			'pageContentActivityByCountryUnique',
			'pageContentActivityByLocaleUnique',
		]),

	},

	methods: {
		async refresh() {
			if (!this.connectedPage) return;

			await this.$store.dispatch('pageInsights/getPageInsights');
			this.$q.notify.success('Erfolgreich aktualisiert!');
		},
	},

	async created() {
		if (this.currentUser.fbPageId) {
			this.$store.dispatch('pageInsights/getPageInsights');
			const { data } = await this.$axios.get('/user/facebook');
			this.connectedPage = data.connected;
		}
	},
};
